import GameFiltersCheckbox from '../GameFiltersCheckbox'
import GameProviderFilters from '../GameProviderFilters'
import { GAME_FILTER_SUPPORT_TYPE } from '../../../constants/uiConfig'

const SearchDropDownPanel = ({
  providersWithStudios, selectedFilter, setSelectedFilter, languageData,
  studios,
  gameFilterSupportType,
}) => {
  if (gameFilterSupportType === GAME_FILTER_SUPPORT_TYPE.PROVIDER_AND_STUDIO) {
    return (
      <GameProviderFilters
        icon='gamepad'
        title={languageData?.providersAndStudios || 'Game Providers & Studios'}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
      />
    )
  }
  if (gameFilterSupportType === GAME_FILTER_SUPPORT_TYPE.STUDIO) {
    return (
      <GameFiltersCheckbox
        dataSet={studios}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        dataType='studio'
        title={languageData?.studio || 'Studio'}
        icon='gamepad'
        type='studio'
      />
    )
  }

  return (
    <GameFiltersCheckbox
      dataSet={providersWithStudios}
      selectedFilter={selectedFilter}
      setSelectedFilter={setSelectedFilter}
      dataType='provider'
      title={languageData?.providers || 'Game Providers'}
      icon='gamepad'
      type='provider-selector'
    />
  )
}

export default SearchDropDownPanel
